import React, {Component} from 'react';
import {Button, Col, Row} from "react-bootstrap";

import "./style.css";
import {toastr} from "react-redux-toastr";

class AdjustmentPanel extends Component {

    constructor(props) {
        super(props);
        this.state = {
            brightness : 0,
            contrast : 0,
            saturation : 0,
            tint : 0,
            blur : 0,
            x_process : 0,
            vignette : 0
        };
    }

    set_state = async state => new Promise(resolve => this.setState(state, resolve));

    isValidInput = (inp, min, max) => {
        if (inp === "") return true;
        let val = parseFloat(inp);
        return (!isNaN(val) && val >= min && val <= max);
    };

    updateFields = function(value){
        var updates = {}
        for(var key in value){
            if(this.state[key] != undefined){
                updates[key] = value[key]
            }
        }

        this.setState(updates)
    }

    handleFiltersOnChange = (event) => {
        var min = -100
        var max = 100
        if(event.target.name === 'vignette') {
            min = 0
        }

        if (this.isValidInput(event.target.value, min, max)) {
            this.set_state({[event.target.name]: event.target.value});
            var value = {}
            value[[event.target.name]] = Number(event.target.value);
            this.props.apply_filter_adjustments(value);
        }
    };

    hideResetBtn = () => (
            this.state.brightness  == 0 &&
            this.state.contrast == 0 &&
            this.state.saturation == 0 &&
            this.state.tint == 0 &&
            this.state.blur == 0 &&
            this.state.x_process == 0 &&
            this.state.vignette == 0
    );

    resetInputs = () => {
        var reset_state = {
            brightness : 0,
            contrast : 0,
            saturation : 0,
            tint : 0,
            blur : 0,
            x_process : 0,
            vignette : 0
        }
        this.setState(reset_state)

        this.props.apply_filter_adjustments(reset_state);
    };

    sanitizeFilterValues = (num) => {
        return (num != "")?parseInt(num, 10):0;
    };

    convertDecimalToHexCode = (num, shift) => {
        return (num + shift).toString(16).padStart(2, '0');
    };

    getFilterCode = () => {
        let brightness = this.convertDecimalToHexCode(this.sanitizeFilterValues(this.state.brightness), 100);
        let contrast = this.convertDecimalToHexCode(this.sanitizeFilterValues(this.state.contrast), 100);
        let saturation = this.convertDecimalToHexCode(this.sanitizeFilterValues(this.state.saturation), 100);
        let tint = this.convertDecimalToHexCode(this.sanitizeFilterValues(this.state.tint), 100);
        let blur = this.convertDecimalToHexCode(this.sanitizeFilterValues(this.state.blur), 100);
        let x_process = this.convertDecimalToHexCode(this.sanitizeFilterValues(this.state.x_process), 100);
        let vignette = this.convertDecimalToHexCode(this.sanitizeFilterValues(this.state.vignette), 0);
        return brightness+contrast+saturation+tint+blur+x_process+vignette;
    };

    applyFilterCode = () => {
      try {
          console.log("success");
      }
      catch (error) {
          toastr.error("That filter code is invalid. Please check it was copied and pasted correctly and try again.")
        }
    };

    render() {
        return (
            <div>
                <Row style={{marginBottom : 10}}>
                    <Col xs={12} style={{borderBottom : '1px solid #cccccc', display : 'table', 'marginBottom' : 20, paddingTop : 5, paddingBottom : 5}}>
                        <span style={{textAlign : 'left', fontWeight : 300, verticalAlign : 'middle', display : 'table-cell', height : 40, fontSize : '1.4rem', cursor: 'pointer'}}></span>
                        {!this.hideResetBtn()?(<Button onClick={this.resetInputs} className="btn-toolbar" style={{float : 'right', fontWeight : 700}}>Reset</Button>):null}
                    </Col>
                    <Col xs={3} className="adjustment-controls-text">
                        Brightness
                    </Col>
                    <Col xs={7}>
                        <input type="range" className="adjustment-slider" name="brightness" min="-100" max="100" value={this.state.brightness} onChange={(e) => this.handleFiltersOnChange(e)}/>
                    </Col>
                    <Col className="filter-adjustment-col" xs={2}>
                        <input type="text" className="adjustment-input-text" name="brightness" onChange={(e) => this.handleFiltersOnChange(e)} value={this.state.brightness}/>
                    </Col>
                </Row>
                <Row style={{marginBottom : 10}}>
                    <Col xs={3} className="adjustment-controls-text">
                        Contrast
                    </Col>
                    <Col xs={7}>
                        <input type="range" className="adjustment-slider" name="contrast" min="-100" max="100" value={this.state.contrast} onChange={(e) => this.handleFiltersOnChange(e)}/>
                    </Col>
                    <Col className="filter-adjustment-col" xs={2}>
                        <input type="text" className="adjustment-input-text" name="contrast" onChange={(e) => this.handleFiltersOnChange(e)} value={this.state.contrast}/>
                    </Col>
                </Row>
                <Row style={{marginBottom : 10}}>
                    <Col xs={3} className="adjustment-controls-text">
                        Saturation
                    </Col>
                    <Col xs={7}>
                        <input type="range" className="adjustment-slider" name="saturation" min="-100" max="100" value={this.state.saturation} onChange={(e) => this.handleFiltersOnChange(e)}/>
                    </Col>
                    <Col className="filter-adjustment-col" xs={2}>
                        <input type="text" className="adjustment-input-text" name="saturation" onChange={(e) => this.handleFiltersOnChange(e)} value={this.state.saturation}/>
                    </Col>
                </Row>
                <Row style={{marginBottom : 10}}>
                    <Col xs={3} className="adjustment-controls-text">
                        Tint
                    </Col>
                    <Col xs={7} className="random-cls">
                        <input type="range" className="adjustment-slider" name="tint" min="-100" max="100" value={this.state.tint} onChange={(e) => this.handleFiltersOnChange(e)}/>
                    </Col>
                    <Col className="filter-adjustment-col" xs={2}>
                        <input type="text" className="adjustment-input-text"  name="tint" onChange={(e) => this.handleFiltersOnChange(e)} value={this.state.tint}/>
                    </Col>
                </Row>
                <Row style={{marginBottom : 10}}>
                    <Col xs={3} className="adjustment-controls-text">
                        Blur
                    </Col>
                    <Col xs={7}>
                        <input type="range" className="adjustment-slider" name="blur" min="-100" max="100" value={this.state.blur} onChange={(e) => this.handleFiltersOnChange(e)}/>
                    </Col>
                    <Col className="filter-adjustment-col" xs={2}>
                        <input type="text" className="adjustment-input-text" name="blur" onChange={(e) => this.handleFiltersOnChange(e)} value={this.state.blur}/>
                    </Col>
                </Row>
                {/* {<Row style={{marginBottom : 10}}>
                    <Col xs={3} className="adjustment-controls-text">
                        X-Process
                    </Col>
                    <Col xs={7}>
                        <input type="range" className="adjustment-slider" name="x_process" min="-100" max="100" value={this.state.x_process} onChange={(e) => this.handleFiltersOnChange(e)}/>
                    </Col>
                    <Col className="filter-adjustment-col" xs={2}>
                        <input type="text" className="adjustment-input-text" name="x_process" onChange={(e) => this.handleFiltersOnChange(e)} value={this.state.x_process}/>
                    </Col>
                </Row>} */}
                <Row style={{marginBottom : 10}}>
                    <Col xs={3} className="adjustment-controls-text">
                        Vignette
                    </Col>
                    <Col xs={7}>
                        <input type="range" className="adjustment-slider" name="vignette" min="0" max="100" value={this.state.vignette} onChange={(e) => this.handleFiltersOnChange(e)}/>
                    </Col>
                    <Col className="filter-adjustment-col" xs={2}>
                        <input type="text" className="adjustment-input-text" name="vignette" onChange={(e) => this.handleFiltersOnChange(e)} value={this.state.vignette}/>
                    </Col>
                </Row>
                {/* <Row style={{position : 'fixed', bottom : 0, paddingLeft : 15, paddingRight : 15, paddingBottom : 20, paddingTop : 20, borderTop : "1px solid #333333"}}> */}
                {/*     <Col className="filter-code-text-col" xs={4}> */}
                {/*         Filter Code */}
                {/*     </Col> */}
                {/*     <Col xs={8}> */}
                {/*         <input className="filter-code-input" type="text"  name="vignette" value={this.getFilterCode()} /> */}
                {/*     </Col> */}
                {/* </Row> */}
            </div>
        );
    }
}

export default AdjustmentPanel;